/**
 * @license
 *
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Request context utilities — API key helpers, context providers, and
 * request data types for authenticated and context-aware flows.
 *
 * ```ts
 * import { apiKey, type ContextProvider } from 'genkit/context';
 * ```
 *
 * @module context
 */

export {
  apiKey,
  getCallableJSON,
  getHttpStatus,
  type ApiKeyContext,
  type ContextProvider,
  type RequestData,
} from '@genkit-ai/core';
